import styled from 'styled-components'
import colors from '../../theme/colors'
import fonts from '../../theme/fonts'

export enum Variant {
  error,
  success,
  normal,
}

export type TextProps = {
  size?: 'medium' | 'large'
  light?: boolean
  variant?: Variant
}

const Text = styled.p<TextProps>`
  margin: 0;
  font-family: ${fonts.fontFamilies.Inter};
  text-align: left;
  font-style: normal;
  letter-spacing: 0em;
  line-height: 24px;

  ${({ variant = Variant.normal, light = false }) => {
    switch (variant) {
      case Variant.normal:
        return `color: ${light ? colors.Primary.GreyTextLight : colors.Primary.GreyText};`
      case Variant.error:
        return `color: ${light ? colors.Action.ErrorRedLight : colors.Action.ErrorRed};`
      case Variant.success:
        return `color: ${light ? colors.Action.SuccessGreenLight : colors.Action.SuccessGreen};`
    }
  }}

  ${({ size = 'medium' }) => {
    if (size === 'medium') {
      return `
      font-size: ${fonts.fontSizes.p16};
      font-weight: ${fonts.fontWeights.small};
  `
    } else if (size === 'large') {
      return `
      font-size: ${fonts.fontSizes.p18};
      font-weight: ${fonts.fontWeights.medium};
  `
    }
  }}
`

export default Text
